export default __webpack_public_path__ + "static/gusto-a81f73e94108965171296edf2cef5dd5.png";